export enum GeometryChunkId {
    Ground = 1,
    Buildings = 2,
    Vegetation = 3,
    Roads = 4,
    Targets = 5,
    Grid = 6,
}
